import React from 'react'
import Loading from '../../../components/loading'
import Empty from '../../../components/empty'
import ConfirmButton from '../../../components/confirmbutton'
import {Table, Form, Message, Dropdown, Image, Icon} from 'semantic-ui-react'
import {connect} from 'react-redux'
import {createAPIClient} from '../../../services/api'
import EditForm from './components/edit'
import {getTemplatesAction} from '../../../actions/template.action'
const {Field, Button} = Form

class TeamSettings extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      members: [],
      isLoading: false,
      newForm: {
        isLoading: false,
        error: undefined,
        postSuccess: false,
        first_name: '',
        last_name: '',
        role: 'Observer',
        email: '',
        templates: []
      },
      searchQuery: null,
      editForm: undefined,
      showEditForm: false
    }
  }

  loadMemberData () {
    const api = createAPIClient()
    this.setState({isLoading: true})
    api.get('/api/users/teammembers')
      .then(response => {
        const members = response.data.response.items
        this.setState({
          members: members,
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          isLoading: false
        })
      })
  }
  componentWillMount () {
    this.loadMemberData()
  }

  onFormSubmit (e) {
    const firstName = this.state.newForm.first_name
    const lastName = this.state.newForm.last_name
    const email = this.state.newForm.email
    const role = this.state.newForm.role
    const templates = this.state.newForm.templates
    this.setState({newForm: Object.assign({}, this.state.newForm, {isLoading: true})})
    const api = createAPIClient()
    const form = {
      first_name: firstName,
      last_name: lastName,
      email: email,
      role: role,
      location: this.props.locations[0],
      templates: templates
    }
    api.post('/api/users/teammembers', form)
      .then(response => {
        this.setState({
          newForm: {
            isLoading: false,
            error: undefined,
            postSuccess: false,
            name: '',
            email: '',
            role: 'Observer',
            templates: []
          }
        })
        this.loadMemberData()
        this.props.getTemplatesAction(results => {
        })
      })
      .catch(error => {
        this.setState({newForm: Object.assign({}, this.state.newForm, {isLoading: false, error: 'This email is already a member'})})
      })
  }
  finishEditing (reload = true) {
    this.setState({showEditForm: false})
    if (reload) {
      this.loadMemberData()
    }
  }
  startEditing (_id) {
    let editMember
    for (let i = 0; i < this.state.members.length; i++) {
      if (this.state.members[i] && this.state.members[i]._id === _id) {
        editMember = Object.assign({}, this.state.members[i])
      }
    }
    this.setState({
      editForm: editMember,
      showEditForm: true
    })
  }
  fieldChange (e) {
    this.setState({
      newForm: Object.assign({}, this.state.newForm, {[e.target.name]: e.target.value})
    })
  }
  onDropDownChange (e, {value}) {
    this.fieldChange({target: {name: 'role', value: value}})
  }
  handleChange (e, { value }) {
    this.setState({
      newForm: Object.assign({}, this.state.newForm, {'templates': value})
    })
  }
  handleSearchChange (e, { searchQuery }) {
    this.setState({ searchQuery })
  }
  render () {
    if (this.state.isLoading) {
      return <Loading />
    }
    const tableRows = (
      <Table.Body>
        {this.state.members.map(member => {
          if (!member) return
          var templatesStr = ''
          for (var i = 0; i < member.templates.length; i++) {
            templatesStr += member.templates[i].name + ', '
          }
          templatesStr = templatesStr.replace(/,\s*$/, '')
          return (

            <Table.Row key={member._id}>
              <Table.Cell>
                {!(this.props.user.role === 'Owner' || this.props.user.role === 'Admin') ? undefined : (
                  <a href='#'>
                    <Image onClick={this.startEditing.bind(this, member._id)} avatar src={'/icons/expand_1369826.svg'} />
                  </a>
                )}
              </Table.Cell>
              <Table.Cell>{member.first_name + ' ' + member.last_name}</Table.Cell>
              <Table.Cell>{member.email}</Table.Cell>
              <Table.Cell>{member.role}</Table.Cell>
              <Table.Cell>{templatesStr}</Table.Cell>
            </Table.Row>
          )
        })}
      </Table.Body>
    )

    const table = (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell style={{width: '50px'}} />
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Role</Table.HeaderCell>
            <Table.HeaderCell>Receive email notifications for</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        {tableRows}
      </Table>
    )
    const memberOptions = [{key: 1, value: 'Observer', text: 'Observer'}, {key: 2, value: 'Admin', text: 'Admin'}]
    const options = this.props.templates.templates.map(template => {
      return {
        'key': template._id,
        'text': template.name,
        'value': template._id
      }
    })
    const form = (
      <div>
        <h2> New team member</h2>
        <Form loading={this.state.newForm.isLoading} onSubmit={this.onFormSubmit.bind(this)}>
          {this.state.newForm.postSuccess ? (<Message positive>
            <Message.Header>Successfully created new custom field</Message.Header>
          </Message>) : undefined}

          {this.state.newForm.error ? (<Message negative>
            <Message.Header>{this.state.newForm.error}</Message.Header>
          </Message>) : undefined}

          <Field>
            <label htmlFor='first_name'>First*</label>
            <input type='text' id='first_name' name='first_name' value={this.state.newForm.first_name} required onChange={this.fieldChange.bind(this)} />
          </Field>
          <Field>
            <label htmlFor='last_name'>Last*</label>
            <input type='text' id='last_name' name='last_name' value={this.state.newForm.last_name} required onChange={this.fieldChange.bind(this)} />
          </Field>
          <Field>
            <label htmlFor='email'>Email*</label>
            <input type='email' id='email' name='email' value={this.state.newForm.email} required onChange={this.fieldChange.bind(this)} />
          </Field>
          <Field>
            <label>Role</label>
            <Dropdown
              placeholder='Select team member'
              fluid selection options={memberOptions}
              onChange={this.onDropDownChange.bind(this)}
              defaultValue='Observer'
            />
          </Field>

          <Field>
            <label>Receive email notifications for</label>
            <Dropdown
              fluid
              selection
              multiple
              search
              options={options}
              value={this.state.newForm.templates}
              placeholder='Select templates'
              onChange={this.handleChange.bind(this)}
              onSearchChange={this.handleSearchChange.bind(this)}
            />
          </Field>
          <Button primary type='submit'>Add member</Button>
        </Form>
      </div>
    )

    return (
      <div>
        <h2>Team</h2>

        {table}
        <br />
        {this.props.user.role === 'Owner' ? form : undefined}
        {this.state.showEditForm ? (<EditForm
          showEditForm={this.state.showEditForm}
          member={this.state.editForm}
          finishEditing={this.finishEditing.bind(this)}
          />) : undefined
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {locations: state.account.user.locations, user: state.account.user, templates: state.templates}
}

export default connect(mapStateToProps, {getTemplatesAction})(TeamSettings)



// WEBPACK FOOTER //
// ./src/pages/settings/team/index.js